module.exports = __webpack_public_path__ + "img/areas.50287cd5.svg";